<hr class="col-span-full border-gray-300 dark:border-gray-700" />
<div class="col-span-full font-header font-(--font-weight-header) text-xl mt-3">
  You may also like:
</div>
<div class="grid grid-cols-1 gap-4 2xl:grid-cols-2 mt-3">
  @for (model of filteringService.relatedModels(); track model.id) {
    <app-model-card [model]="model" (click)="setModelFilter(model.id ?? '')" />
  }
</div>
